export default function IntroDescriptionFallback({ itemsCount = 15 }) {
  const skeletonItems = Array.from({ length: itemsCount }).map((_, index) => (
    <div
      key={index}
      className={`skeleton-item ${index % 4 === 3 ? 'bg-white' : 'bg-grey50'} ${
        index % 3 === 2 ? 'w-4/5' : 'w-full'
      }
      h-4 bg-grey50 rounded-md`}
    ></div>
  ));
  return (
    <div className="grid grid-cols-1 gap-3 my-8 lg:my-16 xl:my-20 xl:mb-16 max-w-[740px] mx-auto animate-pulse">
      <div className="h-12 mb-4 lg:mt-1 lg:mb-8 w-4/5 mx-auto bg-grey50 animate-pulse rounded-md"></div>
      {skeletonItems}
    </div>
  );
}
